import { render, staticRenderFns } from "./MyCheckMedicalTestStatus.vue?vue&type=template&id=6f0a33ed&"
import script from "./MyCheckMedicalTestStatus.vue?vue&type=script&lang=js&"
export * from "./MyCheckMedicalTestStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports